module.exports = __webpack_public_path__ + "img/icon_book_null.068767cc.png";